import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import openSocket from "../../services/socket-io";


import { toast } from "react-toastify";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const useAuth = () => {
	const history = useHistory();
	const [isAuth, setIsAuth] = useState(false);
	const [loading, setLoading] = useState(true);
	const [user, setUser] = useState({});

	useEffect(() => {
		const checkAuthAndBlock = async () => {
			const token = localStorage.getItem("token");
			const storedUser = localStorage.getItem("username");
			
			if (token && storedUser) {
				try {
					const parsedUser = JSON.parse(storedUser);
					
					// Verificar se o sistema está bloqueado
					try {
						const { data: blockData } = await api.get("/settings/systemBlock");
						
						// Se bloqueado e não for usuário ID 1, fazer logout (comparação com == para aceitar string ou number)
						if (blockData.value === "enabled" && parsedUser.id != 1) {
							localStorage.clear();
							api.defaults.headers.Authorization = undefined;
							setIsAuth(false);
							setUser({});
							setLoading(false);
							return;
						}
					} catch (blockErr) {
						console.error("Erro ao verificar bloqueio:", blockErr);
					}
					
					// Com token de 30 dias, restaurar estado se há dados salvos
					setIsAuth(true);
					setUser(parsedUser);
				} catch (err) {
					// Se dados corrompidos, limpar
					localStorage.clear();
					setIsAuth(false);
				}
			}
			setLoading(false);
		};
		
		checkAuthAndBlock();
	}, []);

	useEffect(() => {
		const socket = openSocket();

		socket.on("user", data => {
			if (data.action === "update" && data.user.id === user.id) {
				setUser(data.user);
			}
		});

		return () => {
			socket.disconnect();
		};
	}, [user]);

	const handleLogin = async userData => {
		setLoading(true);

		try {
			const { data } = await api.post("/auth/login", userData);
			
			localStorage.setItem("token", JSON.stringify(data.token));
			localStorage.setItem("username", JSON.stringify(data.user));
			localStorage.setItem("vapidPublicKey", JSON.stringify(data.vapidPublicKey));
			api.defaults.headers.Authorization = `Bearer ${data.token}`;
			setUser(data.user);
			setIsAuth(true);
			toast.success(i18n.t("auth.toasts.success"));
			data.user.profile === "userApi" ? history.push("/connections") : history.push("/tickets");
			setLoading(false);
		} catch (err) {
			toastError(err);
			setLoading(false);
		}
	};

	const handleLogout = async () => {
		setLoading(true);

		try {
			await api.delete("/auth/logout");
			setIsAuth(false);
			setUser({});
			localStorage.removeItem("token");
			localStorage.removeItem("username");
			localStorage.removeItem("vapidPublicKey");
			api.defaults.headers.Authorization = undefined;
			setLoading(false);
			history.push("/login");
		} catch (err) {
			toastError(err);
			setLoading(false);
		}
	};

	return { isAuth, user, loading, handleLogin, handleLogout };
};

export default useAuth;
